// extracted by css-extract-rspack-plugin
export default {"reset":"f793092","root":"a19b619","field":"f0585b2","multiline":"b9209d4","rest-placeholder":"b9a57c9","shift-part":"c16381d","main-part":"f5109a2"};